const UnifiedBanner = ({
  type,
  deadline,
  currentDesktopSrc,
  scheduledDesktopSrc,
  currentMobileSrc,
  scheduledMobileSrc,
  currentDesktopPoster,
  scheduledDesktopPoster,
  currentMobilePoster,
  scheduledMobilePoster,
  url,
  children,
  isVideo = true,
  BottomLeftAlign = false,
  BottomCenterAlign = false
}) => {
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);
  const [isLoading, setIsLoading] = React.useState(true);
  const isDesktop = windowWidth > 589;
  const ShowCurrent = Date.parse(deadline) - Date.parse(new Date().toLocaleString("en-US", {
    timeZone: "America/New_York"
  })) > 0;
  const currentSrc = isDesktop ? currentDesktopSrc : currentMobileSrc;
  const scheduledSrc = isDesktop ? scheduledDesktopSrc : scheduledMobileSrc;
  const srcToShow = ShowCurrent ? currentSrc : scheduledSrc;
  const posterToShowBase = ShowCurrent ? isDesktop ? currentDesktopPoster : currentMobilePoster : isDesktop ? scheduledDesktopPoster : scheduledMobilePoster;
  const posterToShow = isDesktop ? `${posterToShowBase} ?&width=600` : `${posterToShowBase} ?&width=300`;
  React.useEffect(() => {
    function handleResize() {
      setWindowWidth(window.innerWidth);
    }
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const renderBannerContent = () => /*#__PURE__*/React.createElement("div", {
    className: "video-banner-container"
  }, /*#__PURE__*/React.createElement("img", {
    className: `FadeIn ${type}-loading-placeholder ${isDesktop ? 'desktop' : 'mobile'}`,
    src: posterToShow,
    alt: `${type} Placeholder`,
    style: {
      display: isLoading ? 'block' : 'none'
    }
  }), isVideo ? /*#__PURE__*/React.createElement("video", {
    className: `${type}-video ${isDesktop ? 'desktop' : 'mobile'}`,
    key: srcToShow,
    playsInline: true,
    autoPlay: true,
    loop: true,
    muted: true,
    width: "100%",
    poster: posterToShow,
    style: {
      display: isLoading ? 'none' : 'block'
    },
    onLoadedData: () => setIsLoading(false)
  }, /*#__PURE__*/React.createElement("source", {
    src: srcToShow
  })) : /*#__PURE__*/React.createElement("img", {
    className: `${type}-image ${isDesktop ? 'desktop' : 'mobile'}`,
    src: srcToShow,
    alt: `${type} Banner`,
    style: {
      display: isLoading ? 'none' : 'block'
    },
    onLoad: () => setIsLoading(false),
    width: "100%"
  }), /*#__PURE__*/React.createElement("div", {
    className: "video-banner-content-wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: BottomLeftAlign ? "bottom-left-align-container" : BottomCenterAlign ? "bottom-center-align-container" : "video-banner-content-container"
  }, children)));
  return /*#__PURE__*/React.createElement("div", {
    className: "tlf-banner"
  }, url ? /*#__PURE__*/React.createElement("a", {
    href: url
  }, renderBannerContent()) : renderBannerContent());
};
